export default __webpack_public_path__ + "static/media/home-category-wrinkle-care-temporary.38709983.jpg";